//vue
import Vue from 'vue';
import VueRouter from 'vue-router';
//base
import Login from '../views/Login.vue';
import Home from '../views/Home.vue';
//plan
import Plan from '../views/plan/Index.vue';
import PlanList from '../views/plan/List.vue';
import PlanForm from '../views/plan/Form.vue';
import PlanDetails from '../views/plan/Details.vue';
//client
import Client from '../views/client/Index.vue';
import ClientList from '../views/client/List.vue';
import ClientForm from '../views/client/Form.vue';
import ClientDetails from '../views/client/Details.vue';
import ClientCompels from '../views/client/Compels.vue';
//internet
import Internet from '../views/internet/Index.vue';
import InternetList from '../views/internet/List.vue';
import InternetForm from '../views/internet/Form.vue';
import InternetDetails from '../views/internet/Details.vue';
import InternetCompels from '../views/internet/Compels.vue';
import InternetFaturamento from '../views/internet/Faturamento.vue';
import InternetBloqueio from '../views/internet/Bloqueio.vue';
import InternetCobranca from '../views/internet/Cobranca.vue';
import InternetReport from '../views/internet/Report.vue';
//lastmile
import Lastmile from '../views/lastmile/Index.vue';
import LastmileList from '../views/lastmile/List.vue';
import LastmileForm from '../views/lastmile/Form.vue';
import LastmileDetails from '../views/lastmile/Details.vue';
import LastmileReport from '../views/lastmile/Report.vue';
//lan2lan
import Lan2Lan from '../views/lan2lan/Index.vue';
import Lan2LanList from '../views/lan2lan/List.vue';
import Lan2LanForm from '../views/lan2lan/Form.vue';
import Lan2LanDetails from '../views/lan2lan/Details.vue';
import Lan2LanReport from '../views/lan2lan/Report.vue';
//faturamento
import Fatura from '../views/fatura/Index.vue';
import FaturaInternet from '../views/fatura/Internet.vue';
//ferramentas
import Ferramentas from '../views/ferramentas/Index.vue';
import FerramentasList from '../views/ferramentas/List.vue';
import FerramentasWhatsapp from '../views/ferramentas/Whatsapp.vue';


Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: "/home"
  },
  {
    path: '/login',
    component: Login 
  },
  {
    path: '/home',
    component: Home
  },
  {
    path: '/plan',
    component: Plan,
    children: [
      {
        path: "/",
        component: PlanList
      },
      {
        path: "new",
        component: PlanForm
      },
      {
        path: ":id",
        component: PlanDetails
      }
    ]
  },
  {
    path: '/client',
    component: Client,
    children: [
      {
        path: "/",
        component: ClientList
      },
      {
        path: "new",
        component: ClientForm
      },
      {
        path: "compels",
        component: ClientCompels
      },
      {
        path: ":id",
        component: ClientDetails
      }
    ]
  },
  {
    path: '/internet',
    component: Internet,
    children: [
      {
        path: "/",
        component: InternetList
      },
      {
        path: "new",
        component: InternetForm
      },
      {
        path: "compels",
        component: InternetCompels
      },
      {
        path: "faturamento",
        component: InternetFaturamento
      },
      {
        path: "bloqueio",
        component: InternetBloqueio
      },
      {
        path: "cobranca",
        component: InternetCobranca
      },
      {
        path: "report",
        component: InternetReport
      },
      {
        path: ":id",
        component: InternetDetails
      }
    ]
  },
  {
    path: '/lastmile',
    component: Lastmile,
    children: [
      {
        path: "/",
        component: LastmileList
      },
      {
        path: "new",
        component: LastmileForm
      },
      {
        path: "report",
        component: LastmileReport
      },
      {
        path: ":id",
        component: LastmileDetails
      }
    ]
  },
  {
    path: '/lan2lan',
    component: Lan2Lan,
    children: [
      {
        path: "/",
        component: Lan2LanList
      },
      {
        path: "new",
        component: Lan2LanForm
      },
      {
        path: "report",
        component: Lan2LanReport
      },
      {
        path: ":id",
        component: Lan2LanDetails
      }
    ]
  },
  {
    path: '/fatura',
    component: Fatura,
    children: [
      {
        path: "internet",
        component: FaturaInternet
      }
    ]
  },
  {
    path: '/ferramentas',
    component: Ferramentas,
    children: [
      {
        path: "/",
        component: FerramentasList
      },
      {
        path: "whatsapp",
        component: FerramentasWhatsapp
      }
    ]
  }
];

const router = new VueRouter({
  routes
});

export default router;
